import * as React from 'react';
import EventStepper from '../../../../../components/EventStepper';
import { fm } from 'Components/FormatMessage';
import InputHandler from '../../../../../components/InputHandler';
import { formatPartialDate } from 'Utility/date';
import { TechnicalIssueDetails } from '../../../components';

const TechnicalIssueEvents = ({ formData, disabled }: IOwnProps): React.JSX.Element => {
  return (
    <EventStepper
      name="technicalIssues"
      formData={formData}
      stepLabelText={(d: IVNSTechnicalIssueEvent): string => formatPartialDate(d.date)}
      stepContent={(d: IVNSTechnicalIssueEvent): React.JSX.Element => <TechnicalIssueDetails technicalIssue={d} />}
      addNewTextHeader="vns.newTechnicalIssue"
      addNewTextButton="vns.newTechnicalIssue"
      buttonDisabled={disabled}
      buttonDisabledMessage={fm('vns.addGeneratorFirst')}
      previousEventsTextHeader="vns.technicalIssues"
      editingElements={(index: number, onChange: IFormData['onChange']): React.JSX.Element => (
        <React.Fragment>
          <div style={{ marginBottom: '2rem' }}>
            <InputHandler
              type="PartialDate"
              editing={true}
              name="date"
              formData={{
                onChange,
                document: { date: formData.document.technicalIssues?.[index]?.date || '' },
              }}
              dateDefault="now"
              isNotCancellable={true}
              dateHook={{
                dateHookFloor: formData.document.date,
              }}
            />
          </div>
          <div style={{ marginBottom: '2rem' }}>
            <InputHandler
              type="Radio"
              editing={true}
              name="issue"
              formData={{
                onChange,
                document: { issue: formData.document.technicalIssues?.[index]?.issue || '' },
              }}
              options={[
                'batteryBroken',
                'generatorBroken',
                'extensionBroken',
                'jointBetweenExtensionAndGeneratorBroken',
              ]}
              optionFormatter={(name: string | number): React.JSX.Element => fm(`vns.opts.technicalIssue.${name}`)}
            />
          </div>
          <div style={{ marginBottom: '2rem' }}>
            <InputHandler
              type="TextArea"
              editing={true}
              name="additionalInformation"
              formData={{
                onChange,
                document: {
                  additionalInformation: formData.document.technicalIssues?.[index]?.additionalInformation || '',
                },
              }}
              placeholder="vns.technicalIssueAdditionalInformation"
            />
          </div>
        </React.Fragment>
      )}
    />
  );
};

interface IOwnProps {
  formData: IFormData<IVNS>;
  disabled?: boolean;
}

export default TechnicalIssueEvents;
